import { useApi } from '../../api/useApi'
import { Trip } from '../../components/tripTable/TripTable'

const api = useApi()

export interface IFlagTexts {
  info: string | null
  description: string
  personal?: {
    id: number
    namn: string
  }[]
  tableData?: string[][]
  brukare?: {
    id: number
    personnummer: string
    förnamn: string
    efternamn: string
  }[]
  trips?: Trip[]
}

export const fetchFlagTexts = async ({ queryKey }: any): Promise<IFlagTexts> => {
  const [_key, flag, id] = queryKey
  // id_token krävs sedan #51 — detaljvyn scope-kontrolleras nu på samma sätt som
  // flagglistorna, och backend behöver veta vem som frågar.
  return await api
    .get(`/v1/text/${localStorage.getItem('tenant_id')}/flag/${flag}/${id}?id_token=${localStorage.getItem('hydra_id_token')}`, {
      headers: {
        authorization: 'Bearer ' + localStorage.getItem('hydra_access_token'),
      },
    })
    .then((res) => res.data)
}
